// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer-module--Footer--1V0vt"};